import { createApp } from 'vue';
import CalendarPageVue from './calendar-page.vue';
import { waitForBootstrap } from '../../components/bootstrap-helpers';

export class CalendarPage {
    constructor(el, options) {
        this.props = options;
        this.init(el);
    }

    init(el) {
        const app = createApp(CalendarPageVue, this.props);
        waitForBootstrap(() => app.mount(el));
    }
}
